<template>
    <div class="form-group form-group--expandable"
         :class="{'form-group--expanded': showContents}">
        <div class="control-label"
             @click.prevent="setExpanded(!modelValue)">
            <label>{{ l(label) }}</label>
            <i v-if="!forceExpanded"
               class="fas"
               :class="[modelValue ? 'fa-chevron-up' : 'fa-chevron-down'] " />
        </div>

        <div v-show="showContents">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // You can use v-model to set the expanded state,
        // so the input prop needs to be called value.
        modelValue: {
            type: Boolean,
            default: false,
        },

        label: {
            type: String,
            required: true,
        },

        forceExpanded: {
            type: Boolean,
            default: true,
        },
    },

    emits: [
        'expanded',
        'update:modelValue',
    ],

    computed: {
        showContents() {
            return this.modelValue || this.forceExpanded;
        },
    },

    methods: {
        setExpanded(value) {
            this.$emit('update:modelValue', value);

            if (value) {
                // Wait for nextTick so the UI is updated and the child elements exist.
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$emit('expanded');
                    }, 10);
                });
            }
        },
    },
};
</script>
